import { render, staticRenderFns } from "./neighborhood-map.vue?vue&type=template&id=e84c1cae&"
import script from "./neighborhood-map.vue?vue&type=script&lang=js&"
export * from "./neighborhood-map.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports